module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j6mZl"))).then(() => parcelRequire('cvs7o'));